// src/components/FullApp.js

import React, { useState, useEffect } from 'react';
import MagicAppear from './react-search-fetch';
import Login from '../auth/Login';
import '../auth/Login.css';
import Register from '../auth/Register';
import Header from './Header';

const FullApp = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [currentView, setCurrentView] = useState('login'); // 'login' or 'register'

    useEffect(() => {
        const token = localStorage.getItem('user-token') || localStorage.getItem('user'); // Check both just in case
        if (token) {
            setIsAuthenticated(true);
        }
    }, []);

    const handleLoginSuccess = () => {
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('user-token');
        localStorage.removeItem('user');
        setIsAuthenticated(false);
        setCurrentView('login');
    };

    const handleRegisterSuccess = () => {
        setCurrentView('login');
    };

    return (
        <div className="App">
            <Header isAuthenticated={isAuthenticated} onLogout={handleLogout} />
            {isAuthenticated ? (
                <MagicAppear />
            ) : (
                currentView === 'login' ? (
                    <Login
                        onLoginSuccess={handleLoginSuccess}
                        onGoToRegister={() => setCurrentView('register')}
                    />
                ) : (
                    <Register
                        onRegisterSuccess={handleRegisterSuccess}
                        onGoToLogin={() => setCurrentView('login')}
                    />
                )
            )}
        </div>
    );
};

export default FullApp;